import { render, staticRenderFns } from "./gdpr-prompt.vue?vue&type=template&id=2e7a1838&scoped=true&"
import script from "./gdpr-prompt.vue?vue&type=script&lang=js&"
export * from "./gdpr-prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a1838",
  null
  
)

export default component.exports